<div class="modelContainer">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Rename Model
  </div>
  <div class="modelBody">
    <form #flowSheetForm="ngForm">
      <div mat-dialog-content>
        <div class="form-group row no-overflow flowsheetSave">
          <div class="col-sm-12 pad-lr">
            <div class="row mb-18">
              <div class="col-sm-4">
                <label for="name" class="form-label"><strong>Model Name</strong></label>
                <span class="text-danger star-danger">*</span>
              </div>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="name"
                       name="name"
                       [(ngModel)]="modelName"
                       #name="ngModel"
                       maxlength="30"
                       (keyup)="validateKey($event)"
                       required>
                <div *ngIf="!name.valid && name.touched" class="text-danger mt-2">
                  A name is required for Model.
                </div>
                <div *ngIf="name.valid && name.touched && nameExist" class="text-danger mt-2">
                  This name already exists, please enter a different name.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="alignCenter">
        <button class="saveBtn2 actionBtn" [disabled]="!name.valid || nameExist" (click)="saveWorkflow()">Save</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

